import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider, CssBaseline, Box } from '@mui/material'
import { Provider } from 'react-redux'
import { store } from './store'
import theme from './theme/index.ts'
import Layout from './components/Layout.tsx'
import ProtectedRoute from './components/ProtectedRoute'
import RoleRouteGuard from './components/RoleRouteGuard'
import RoleSelectGate from './components/RoleSelectGate'
import ProfilePage from './pages/ProfilePage'
import CasesEntryRoute from './components/CasesEntryRoute'
import CaseDetailPage from './pages/cases/CaseDetailPage'
import NewCasePage from './pages/cases/NewCasePage'
import EvidenceSubmitPage from './pages/cases/EvidenceSubmitPage'
import WorkspacePage from './pages/workspace/WorkspacePage'
import WorkspaceCaseDetailPage from './pages/workspace/WorkspaceCaseDetailPage'
import ReportsPage from './pages/workspace/ReportsPage'
import PreliminaryProcessingPage from './pages/workspace/PreliminaryProcessingPage'
import PreliminaryChiefPage from './pages/workspace/PreliminaryChiefPage'
import DocumentsPendingPage from './pages/workspace/DocumentsPendingPage'
import AssignCaseListPage from './pages/workspace/AssignCaseListPage'
import AssignJudgePage from './pages/workspace/AssignJudgePage'
import SettingsPage from './pages/workspace/SettingsPage'
import VideoConferencePage from './pages/workspace/VideoConferencePage'
import AIDraftPage from './pages/workspace/AIDraftPage'
import AIEvidencePage from './pages/workspace/AIEvidencePage'
import AIResearchPage from './pages/workspace/AIResearchPage.tsx'
import CourtSecretaryPage from './pages/workspace/CourtSecretaryPage'
import NotFoundPage from './pages/NotFoundPage'
import RoleSelectPage from './pages/RoleSelectPage.tsx'
import { WORKSPACE_SECTION_IDS } from './pages/workspace/workspaceSectionIds'

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ height: '100%', width: '100%', margin: 0, padding: 0 }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<RoleSelectGate />} />
              {/* Luôn mở được màn chọn vai trò (kể cả đã có token) — xem nền / demo */}
              <Route path="/role-select" element={<RoleSelectPage />} />
              <Route path="/*" element={<ProtectedRoute><RoleRouteGuard><Layout /></RoleRouteGuard></ProtectedRoute>}>
                <Route path="profile" element={<ProfilePage />} />
                <Route path="cases" element={<CasesEntryRoute />} />
                <Route path="cases/new" element={<NewCasePage />} />
                <Route path="cases/evidence" element={<EvidenceSubmitPage />} />
                <Route path="cases/:caseId" element={<CaseDetailPage />} />
                <Route path="workspace" element={<WorkspacePage />} />
                <Route path="workspace/cases/:caseId" element={<WorkspaceCaseDetailPage />} />
                <Route path="workspace/cases" element={<Navigate to={`/workspace#${WORKSPACE_SECTION_IDS.danhSachAn}`} replace />} />
                <Route path="workspace/preliminary" element={<PreliminaryProcessingPage />} />
                <Route path="workspace/preliminary-chief" element={<PreliminaryChiefPage />} />
                <Route path="workspace/documents-pending" element={<DocumentsPendingPage />} />
                <Route path="workspace/calendar" element={<Navigate to={`/workspace#${WORKSPACE_SECTION_IDS.lichLamViec}`} replace />} />
                <Route path="workspace/reports" element={<ReportsPage />} />
                <Route path="workspace/assign" element={<AssignCaseListPage />} />
                <Route path="workspace/assign/:caseId" element={<AssignJudgePage />} />
                <Route path="workspace/settings" element={<SettingsPage />} />
                <Route path="workspace/video" element={<VideoConferencePage />} />
                <Route path="workspace/ai-draft" element={<AIDraftPage />} />
                <Route path="workspace/ai-evidence" element={<AIEvidencePage />} />
                <Route path="workspace/ai-research" element={<AIResearchPage />} />
                <Route path="workspace/court-secretary" element={<Navigate to="/workspace/ai-court-secretary" replace />} />
                <Route path="workspace/ai-court-secretary" element={<CourtSecretaryPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </Box>
      </ThemeProvider>
    </Provider>
  )
}

export default App
